import { LStorage } from '@shared/Storage';


if (window.location.href.includes('debug-mode=true')) {
    LStorage.setItem('debugMode', true);
}

export const DebugFlag = {
    mapNoState: window.location.href.includes('no-state'),
    mapNoImages: window.location.href.includes('no-images'),
    mapNoDocs: window.location.href.includes('no-docs'),
    debugMode: LStorage.getOrDefault('debugMode', false),
};

Object.entries(DebugFlag).forEach(([key, val]) => {
    console.log(key, val);
});
